import { create } from 'zustand';
import type { User, Notification, ScenarioType, Quarter } from '../types/entities';

interface SessionState {
  user: User;
  notifications: Notification[];
  darkMode: boolean;
  scenario: ScenarioType;
  quarter: Quarter;
  toggleDarkMode: () => void;
  setScenario: (scenario: ScenarioType) => void;
  setQuarter: (quarter: Quarter) => void;
  markNotificationRead: (id: string) => void;
}

export const useSessionStore = create<SessionState>((set) => ({
  scenario: 'BASE',
  setScenario: (scenario) => set({ scenario }),
  quarter: 'Q4',
  setQuarter: (quarter) => set({ quarter }),
  user: {
    name: 'David Richardson',
    email: 'd.richardson@ukbankplc.com',
    role: 'Chief Financial Officer (SMF2)',
    smfCode: 'SMF2',
  },
  notifications: [
    {
      id: 'n1',
      type: 'INFO',
      title: 'Q4 management accounts finalized',
      message: 'All divisional P&Ls reconciled and approved',
      timestamp: '2025-01-06T12:00:00Z',
    },
    {
      id: 'n2',
      type: 'WARNING',
      title: 'Cost-to-income ratio above target',
      message: 'Q4 C/I at 52.3%, target 50.0%',
      timestamp: '2025-01-06T09:00:00Z',
    },
    {
      id: 'n3',
      type: 'SUCCESS',
      title: 'FY25 budget approved by Board',
      message: '£2.58B revenue target confirmed',
      timestamp: '2025-01-05T15:00:00Z',
    },
  ],
  darkMode: false,
  toggleDarkMode: () => set((state) => {
    const newDarkMode = !state.darkMode;
    if (newDarkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    return { darkMode: newDarkMode };
  }),
  markNotificationRead: (id: string) =>
    set((state) => ({
      notifications: state.notifications.filter((n) => n.id !== id),
    })),
}));
